"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var test_attributes_1 = require("@carvana/test-attributes");
var PlateVinEntry_1 = __importDefault(require("./PlateVinEntry"));
var VehicleEntry = function (_a) {
    var submitPlateVin = _a.submitPlateVin, submitText = _a.submitText, queryParams = _a.queryParams;
    return ((0, jsx_runtime_1.jsx)(PlateVinEntry_1.default, { submitPlateVin: submitPlateVin, submitText: submitText, queryParams: queryParams }));
};
exports.default = (0, test_attributes_1.appendTestContext)('Hero')(VehicleEntry);
